import { apiClient } from '@store/index';
import { AIAssistant, AIAssistantCreate, AIAssistantDelete, AIAssistantImport, AIAssistantUpdate } from './';
import { axiosErrorMiddleware } from '@requests/common';
import { v4 as uuidv4 } from 'uuid';

const list = async (): Promise<AIAssistant[]> => {
  const url = `/assistants`;
  const response = await apiClient.get<AIAssistant[]>(url);
  return response.data.sort((a, b) => a.name.localeCompare(b.name));
};

const create = async ({ assistant }: AIAssistantCreate) => {
  try {
    const response = await apiClient.post<AIAssistant>(`/assistants`, { assistant });
    return response.data;
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

const update = async ({ assistantId, assistant }: AIAssistantUpdate) => {
  try {
    await apiClient.patch(`/assistants/${assistantId}`, assistant);
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

const remove = async ({ assistantId }: AIAssistantDelete) => {
  try {
    await apiClient.delete(`/assistants/${assistantId}`);
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

const importAssistant = async ({ assistant }: AIAssistantImport) => {
  try {
    const assistantPayload = {
      ...assistant,
      tools: [],
      id: null,
      insight_settings: undefined,
    };

    const response = await apiClient.post<AIAssistant>(`/assistants`, { assistant: assistantPayload });
    const newAssistant = response.data;

    if (newAssistant) {
      for (const tool of assistant.tools) {
        const toolPayoad = { ...tool, id: uuidv4(), assistant_id: newAssistant.id };
        await apiClient.post(`/assistants/${newAssistant.id}/tools`, { tool: toolPayoad });
      }
    }

    return { ...newAssistant, tools: assistant.tools };
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

export default { list, create, update, remove, importAssistant };
